import ShareButton from '@anm/components/share/ShareButton';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const WaveEventInfoWrapperTabletStyles = media.tablet`
    height: 100%;
    &:after, &:before {
        display: none;
    }
`;

export const WaveEventInfoBorderedTabletStyles = media.tablet`
    max-height: inherit;
    overflow-x: hidden;
    overflow-y: auto;
    max-width: 100%;
    border-radius: 0;
    padding: 16px 20px 30px;
    height: 100%;
`;

export const WaveEventButtonContainerTabletStyles = media.tablet`
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 0;
    margin-top: auto;
    flex-wrap: inherit;
    flex-shrink: 0;
`;

export const ShareLinkButtonDifferentOnMobileStyles = media.tablet`
    width: 100%;
    color: #fff;
    background-color: var(--blue_100);
    text-transform: none;
    border: 0 none;
    &:hover {
      background-color: #0a86a4;
    }
`;
export const ShareLinkButtonDifferentOnMobile = styled(ShareButton)<{
  link: string;
}>`
  ${ShareLinkButtonDifferentOnMobileStyles};
`;

export const WaveEventButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  flex-wrap: wrap;
  ${WaveEventButtonContainerTabletStyles};
`;

export const WaveEventButtonContainerBottomTabletStyles = media.tablet`
    > * {
        flex-basis: 50%;
        flex-grow: 0;
        &:nth-child(2) {
          margin-left: 20px;
        }
      }
`;

export const WaveEventButtonContainerBottom = styled.div`
  display: flex;
  > * {
    &:last-child {
      margin-left: 30px;
    }
  }
  ${WaveEventButtonContainerBottomTabletStyles};
`;

export default WaveEventButtonContainer;
